









import { mapGetters } from 'vuex';

export default {
  name: 'LogoImage',
  computed: {
    ...mapGetters({
      getSeasonalDecoration: 'configs/getSeasonalDecoration'
    }),
    getDecoration () {
      return this.getSeasonalDecoration && this.getSeasonalDecoration.length ? this.getSeasonalDecoration.find(s => s.value) : {}
    },
    logoDecoration () {
      if (this.getDecoration) {
        return this.getDecoration.key === 'snowflakes' ? '/assets/logo-new-year' : '/assets/logo-valentine-day'
      }
      return false
    }
  }
}
